import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateDishTypeSimpleDetails(
    $id: ID!
    $data: DishTypeSimpleDetailsInput!
  ) {
    updateDishTypeSimpleDetails(id: $id, data: $data) {
      id
      position
      updatedAt
      isExcludedFromSearch
      isExcludedFromBrowsing

      updatedBy {
        id
        name
      }

      description
      synonyms
    }
  }
`

export default UPDATE_DISH_TYPE_SIMPLE_DETAILS_MUTATION
